import React, { FC, useEffect, useState } from "react"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"

import { getImgixImageData } from "@utils"

import Modal from "@components/Modal/Modal"
import PlayButton from "@components/PlayButton/PlayButton"
import { Wistia } from "@helpscout/hs-marketing-shared-components"

import PnpPlayer from "./PnpPlayer/PnpPlayer"

import "./WistiaPopover.scss"

type WistiaPopoverProps = {
  forceModalOpen?: boolean,
  id: string,
  imageData?: IGatsbyImageData,
  imageSrc?: string,
  imageAlt: string,
  maxWidth?: number,
  onClose?: () => void,
  onOpen?: () => void,
  usePnpPlayer?: boolean,
}

const WistiaPopover: FC<WistiaPopoverProps> = ({
  forceModalOpen,
  id,
  imageData,
  imageSrc,
  imageAlt,
  maxWidth = 625,
  onClose,
  onOpen,
  usePnpPlayer,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const closeModal = () => {
    setIsOpen(false)
    if (onClose) onClose()
  }

  useEffect(() => {
    if (forceModalOpen) setIsOpen(true)
  }, [forceModalOpen])

  return (
    <>
      <button
        className="WistiaPopover"
        onClick={() => setIsOpen(true)} aria-label="Click to watch the video"
      >
        {(imageData || imageSrc) && (
          <GatsbyImage
            alt={imageAlt || "Video Player"}
            image={imageData || getImgixImageData(imageSrc || "", maxWidth, 1.78)}
            style={{ maxWidth: `${maxWidth}px` }}
          />
        )}
        <div className="WistiaPopover--PlayButton">
          <PlayButton />
        </div>
      </button>

      {isOpen && !usePnpPlayer && (
        <Modal
          onClose={closeModal}
          onOpen={onOpen}
          renderWithoutBox
        >
          <div className="WistiaPopover--Video">
            <Wistia autoPlay id={id} />
          </div>
        </Modal>
      )}

      {isOpen && usePnpPlayer && (
        <PnpPlayer
          onClose={closeModal}
        >
          <Wistia autoPlay id={id} />
        </PnpPlayer>
      )}
    </>
  )
}

export default WistiaPopover
